import { Component } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

@Component({
    selector: `psm-two-sections-horizontal-layout-component`,
    templateUrl: 'twoSectionsHorizontalLayoutMirror.component.html',
    styleUrls: ['../layout.component.scss']
})

export class TwoSectionsHorizontalLayoutMirrorComponent extends LayoutComponent { }

export class TwoSectionsHorizontalLayoutMirror extends Layout {
    public type = 'TwoSectionsHorizontalLayoutMirror';
    public componentType = TwoSectionsHorizontalLayoutMirrorComponent;
    public numberOfSections = 2;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/twoSectionsHorizontalLayoutMirror/twoSectionsHorizontalLayoutMirror.component.ts